import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatDateTime } from "@/lib/format";
import { Activity as ActivityIcon } from "lucide-react";

const TYPES = ["all", "client", "task", "document", "user", "folder", "session", "pending_document"];

export default function ActivityPage() {
  const [items, setItems] = useState([]);
  const [typeF, setTypeF] = useState("all");
  useEffect(() => {
    const params = {};
    if (typeF !== "all") params.entity_type = typeF;
    api.get("/activity", { params }).then(({ data }) => setItems(data));
  }, [typeF]);

  return (
    <div className="space-y-4" data-testid="activity-page">
      <div className="flex items-center gap-3">
        <p className="text-sm text-muted-foreground flex-1">Every action across the firm, in chronological order.</p>
        <Select value={typeF} onValueChange={setTypeF}>
          <SelectTrigger className="h-9 w-44" data-testid="activity-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            {TYPES.map((t) => <SelectItem key={t} value={t} className="capitalize">{t.replace("_", " ")}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="border border-border rounded-md overflow-hidden">
        {items.length === 0 && (
          <div className="p-10 text-center text-sm text-muted-foreground">
            <ActivityIcon size={20} className="mx-auto text-muted-foreground/40 mb-3" />
            No activity yet.
          </div>
        )}
        {items.map((a) => (
          <div key={a.id} className="px-4 py-2.5 border-b border-border last:border-0 flex items-center gap-3 text-sm hover:bg-muted/40" data-testid={`activity-${a.id}`}>
            <span className="font-medium">{a.actor_name}</span>
            <span className="text-muted-foreground">{a.action}</span>
            <span className="text-muted-foreground text-xs uppercase font-mono">{a.entity_type}</span>
            {a.entity_label && <span className="font-medium truncate">{a.entity_label}</span>}
            {a.detail && <span className="text-muted-foreground italic truncate max-w-md">&ldquo;{a.detail}&rdquo;</span>}
            <div className="flex-1" />
            <span className="text-xs text-muted-foreground font-mono">{formatDateTime(a.created_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
